var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5.0 -10.0 110.0 135.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m93.75 0h-87.5c-3.4375 0-6.25 2.8125-6.25 6.25v6.25c0 3.4375 2.8125 6.25 6.25 6.25 0.53125 0-0.3125-5.7188 8.75 72.938 0.53125 4.7188 4.5625 8.3125 9.3125 8.3125h51.375c4.75 0 8.7812-3.5625 9.3125-8.3125l7.2812-63.062c0.1875-1.7188-1.0312-3.25-2.75-3.4688-1.6875-0.21875-3.25 1.0312-3.4688 2.75l-7.2812 63.062c-0.1875 1.5625-1.5312 2.75-3.0938 2.75h-51.375c-1.5938 0-2.9062-1.1875-3.0938-2.7812l-8.3438-72.188h80.875c3.4375 0 6.25-2.8125 6.25-6.25v-6.25c0-3.4375-2.8125-6.25-6.25-6.25zm-87.5 12.5v-6.25h87.5v6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.25 78.125c-1.625 0-3-1.25-3.125-2.875l-3.125-40.625c-0.125-1.7188 1.1562-3.2188 2.875-3.3438 1.75-0.125 3.2188 1.1562 3.3438 2.875l3.125 40.625c0.125 1.8125-1.2812 3.375-3.125 3.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.75 78.125c-1.8438 0-3.25-1.5625-3.125-3.375l3.125-40.625c0.125-1.7188 1.5938-3 3.3438-2.875 1.7188 0.125 3 1.625 2.875 3.3438l-3.125 40.625c-0.125 1.625-1.5 2.875-3.125 2.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 78.125c-1.7188 0-3.125-1.4062-3.125-3.125v-40.625c0-1.7188 1.4062-3.125 3.125-3.125s3.125 1.4062 3.125 3.125v40.625c0 1.7188-1.4062 3.125-3.125 3.125z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.b791d6f7.svg";
export { ForwardRef as ReactComponent };